<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('cancel')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :dark="!sameInput" :disabled="sameInput" @click="submit">
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <v-layout row wrap>
            <v-flex sm12 md5 class="layout column align-center">
              <v-avatar
                size="256"
                :tile="$vuetify.breakpoint.mdAndUp"
                class="thumbnail viewer"
                v-viewer
              >
                <img
                  v-lazy="c.PHOTO_PROFIL_URL + input.photo_profil"
                  alt="Photo User"
                  class="portrait"
                />
              </v-avatar>
            </v-flex>
            <v-flex sm12 md7>
              <v-text-field
                v-if="dialog"
                autofocus
                append-icon="person"
                type="text"
                v-model="input.username"
                v-validate="'required'"
                name="username"
                data-vv-name="username"
                label="Username"
                data-vv-as="Username"
                :error-messages="errors.collect('username')"
              >
              </v-text-field>
              <v-text-field
                append-icon="mail"
                type="text"
                v-model="input.email"
                v-validate="'email'"
                name="email"
                data-vv-name="email"
                label="E-Mail"
                data-vv-as="E-Mail"
                :error-messages="errors.collect('email')"
              >
              </v-text-field>
              <v-select
                append-icon="gavel"
                attach
                item-text="role"
                item-value="id_role"
                :items="role"
                v-model="input.id_role"
                v-validate="'required'"
                name="id_role"
                data-vv-name="id_role"
                label="Role"
                data-vv-as="Role"
                :error-messages="errors.collect('id_role')"
              >
                <template slot="item" slot-scope="data">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ data.item.role }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      data.item.role_desc
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-select>
              <v-select
                append-icon="flash_on"
                attach
                hide-details
                item-text="val"
                item-value="key"
                :items="optionsActiveUser"
                v-model="input.active_user"
                label="Status"
              >
              </v-select>
              <v-btn
                :color="fieldPassword ? 'secondary' : 'primary'"
                class="mx-0 mb-2"
                v-if="action != 'ADD'"
                @click="toggleFieldPassword"
                dark
                small
                >{{ fieldPassword ? "BATALKAN" : "" }} RESET PASSWORD
              </v-btn>
              <v-text-field
                v-if="fieldPassword || action == 'ADD'"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                :append-icon-cb="() => (showPassword = !showPassword)"
                hint="*Password harus mengandung Huruf besar, Huruf kecil, Angka, dan Simbol"
                persistent-hint
                v-model="input.password"
                v-validate="'required|min:8|max:10|valid_password'"
                name="password"
                data-vv-name="password"
                label="Password"
                data-vv-as="Password"
                :error-messages="errors.collect('password')"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import _ from "lodash";
import c from "@/constants";
import { mapState } from "vuex";

const defaultInput = {
  username: "",
  email: "",
  role: "",
  password: "",
  photo_profil: "unknown.png",
  active_user: "1"
};

export default {
  name: "user-input",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      input: _.cloneDeep(defaultInput),
      dataInjected: null,
      optionsActiveUser: [
        { key: "1", val: "AKTIF" },
        { key: "0", val: "BLOKIR" }
      ],
      showPassword: false,
      fieldPassword: false,
      c: c
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("user", ["role"]),
    source() {
      return this.$store.state[this.primary_field][this.primary_field];
    },
    titleDialog() {
      let title = this.action == "ADD" ? "TAMBAH" : "EDIT";
      return `${title} ${this.title}`;
    },
    sameInput() {
      return _.isEqual(this.input, this.dataInjected);
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch(
              `${this.primary_field}/${this.action}_${this.title}`,
              this.input
            )
            .then(() => {
              let new_id =
                this.action == "ADD"
                  ? _.last(this.source)[this.primary_key]
                  : null;
              this.$emit("submitted", new_id);
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    },
    toggleFieldPassword() {
      this.fieldPassword = !this.fieldPassword;
      if (this.fieldPassword) this.input.password = "";
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$validator.reset();
        if (this.action == "ADD") {
          this.dataInjected = _.cloneDeep(defaultInput);
        } else {
          this.dataInjected = _.cloneDeep(this.data);
        }
        this.fieldPassword = false;
        this.dataInjected.password = "";
        this.input = _.cloneDeep(this.dataInjected);
      }
    }
  },
  mounted() {
    this.$store.dispatch("user/GET_USER");
    this.$store.dispatch("user/GET_OPTIONS");
  }
};
</script>
